import React from 'react';
import Link from 'gatsby-link';
import Template from '../../../../components/templates/LoreHookConnect';
import Markdown from '../../../../components/Markdown';

export default (props) => {
  return (
    <Template>
      <h1>
        byId
      </h1>
      <p>
        The <code>byId</code> blueprint...
      </p>
    </Template>
  )
};



// WEBPACK FOOTER //
// ./src/pages/hooks/lore-hook-connect/blueprints/byId.js